/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_PURCHASE_ORDERS, GET_PURCHASE_ORDERS, SET_PURCHASE_ORDERS } from 'src/actions/purchaseOrderAction';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const purchaseOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PURCHASE_ORDERS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_PURCHASE_ORDERS: {
      const { purchaseOrders, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = purchaseOrders;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    case SET_PURCHASE_ORDERS: {
      const { purchaseOrders } = action.payload;

      return produce(state, (draft) => {
        draft.items = branches;
      });
    }

    default:
      return state;
  }
};

export default purchaseOrderReducer;
